import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SearchSite, Site } from '@/apis/sites/types/sitesApi';
import { siteFromApiAdapter } from '@/apis/sites/adapters/sitesFromApiAdapter';
import { prepareHeadersWithAuthorization as prepareHeaders } from '@/apis/headers';
import { searchSitesFromApiAdapter } from '@/apis/sites/adapters/searchSitesFromApiAdapter';

const BASE_URL = import.meta.env.VITE_APP_API_URL;

export interface SearchSitesParams {
  limit?: number;
  query?: string;
}

export const sitesApi = createApi({
  reducerPath: 'sitesApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL, prepareHeaders }),
  endpoints: (builder) => ({
    getSiteById: builder.query<Site, number>({
      query: (siteId) => ({
        url: `/sites/${siteId}`,
      }),
      transformResponse: siteFromApiAdapter,
    }),
    searchSites: builder.query<SearchSite[], SearchSitesParams>({
      query: ({ query, limit }) => ({
        url: '/sites/search',
        params: {
          ...(query && { query }),
          ...(limit && { limit }),
        },
      }),
      transformResponse: searchSitesFromApiAdapter,
    }),
  }),
});

export const { useGetSiteByIdQuery, useSearchSitesQuery } = sitesApi;
